import styled from 'styled-components';

export const PerfectDiaperGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columnSize}, 1fr);
  grid-gap: ${(props) => (props.newDiaperVersion ? '32px' : '24px')};
  margin: ${(props) => (props.newDiaperVersion ? '0 10% 16px' : '0 10px 16px')};
  @media (max-width: 720px) {
    grid-template-columns: 100%;
    margin: ${(props) => (props.newDiaperVersion ? '0 0 16px' : '0 10px 16px')};
    grid-gap: ${(props) => (props.newDiaperVersion ? '0' : '24px')};
  }
`;

export const ImageBox = styled.div`
  position: relative;
  width: 100%;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  cursor: pointer;
  span {
    position: unset !important;
  }

  .image {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
  .carousel-desktop {
    @media (max-width: 720px) {
      display: none !important;
    }
  }
  .carousel-mobile {
    display: none !important;
    @media (max-width: 720px) {
      display: block !important;
    }
  }

  @media (max-width: 720px) {
    cursor: default;
  }

  &:hover {
    transform: scale(1.02);
  }
`;

export const AbsoluteText = styled.p`
  position: absolute;
  left: 24px;
  width: 50%;
  top: 10%;
  font-weight: 600;
  color: ${(props) => props.color};
  font-size: calc(0.7em + 0.9vw);
  letter-spacing: 0.8px;

  @media (max-width: 720px) {
    width: 47%;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const ContentBox = styled.div`
  position: absolute;
  left: 24px;
  top: 10%;
  @media (max-width: 720px) {
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
  }
`;

export const ImageHeading = styled.h2`
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 75%);
  font-size: clamp(1rem, 2vw, 1.5rem);
  width: 67%;
  letter-spacing: 0.8px;

  @media (max-width: 720px) {
    width: 54%;
    letter-spacing: 0;
  }
`;

export const ImageDescription = styled.p`
  font-size: clamp(10px, 2vw, 15px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 74%);
  padding-top: 8px;
  line-height: 17px;
  width: 70%;

  @media (max-width: 720px) {
    width: 64%;
    padding-top: 4px;
  }
`;
